'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@common/components';
import { Fragment } from 'react';
import { TABS } from '../constants';
interface TabProductInfoProps {
  productInfoSections: Array<{
    sectionName: string;
    items: Array<{
      key: string;
      value: string;
    }>;
  }>;
  vendorName: string;
  vendorContactNumber: string;
}
export const TabProductInfo = t0 => {
  const $ = _c(18);
  const {
    productInfoSections,
    vendorName,
    vendorContactNumber
  } = t0;
  let t1;
  if ($[0] !== vendorName) {
    t1 = {
      key: "\uC0DD\uC0B0\uC790",
      value: vendorName
    };
    $[0] = vendorName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== vendorContactNumber) {
    t2 = {
      key: "\uC5F0\uB77D\uCC98",
      value: vendorContactNumber
    };
    $[2] = vendorContactNumber;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = [t1, t2];
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const vendorItems = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h3 className="font-700 text-Gray-900 typo-h5">상품정보</h3>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== productInfoSections) {
    t5 = productInfoSections.map(_temp);
    $[8] = productInfoSections;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className="flex flex-col gap-16 pb-12">{t4}{t5}</div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h3 className="font-700 text-Gray-900 typo-h5">생산자 정보</h3>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== vendorItems) {
    t8 = <div className="flex flex-col gap-16">{t7}<div className="flex flex-col gap-12">{vendorItems.map((item_0, index_0) => <Fragment key={item_0.key}><div className="flex flex-col gap-4"><span className="w-100 font-400 text-Gray-600 typo-body3">{item_0.key}</span><span className="font-400 text-Gray-900 typo-body3">{item_0.value}</span></div>{index_0 < vendorItems.length - 1 && <Divider />}</Fragment>)}</div></div>;
    $[13] = vendorItems;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <section id={TABS.INFO}><div className="flex flex-col gap-32 px-20 mobile-tablet:gap-20">{t6}{t8}</div></section>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
function _temp(section) {
  return <div key={section.sectionName} className="flex flex-col gap-12">{section.items.map((item, index) => <Fragment key={item.key}><div className="flex flex-col gap-4"><span className="font-400 text-Gray-600 typo-body3">{item.key}</span><span className="font-400 text-Gray-900 typo-body3">{item.value}</span></div>{index < section.items.length - 1 && <Divider />}</Fragment>)}</div>;
}